var colorSlide = document.querySelector('.main-swatches-slider');

if (colorSlide) {
  const swiper = new Swiper('.main-swatches-slider', {
    slidesPerView: 8.5,
    spaceBetween: 5,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    initialSlide: 0,
    centeredSlides: true,
    centeredSlidesBounds: true,
    navigation: {
      nextEl: '.pdp-swatches-next',
      prevEl: '.pdp-swatches-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 13.5,
      },
      768: {
        slidesPerView: 18,
      },
      990: {
        slidesPerView: 9.75,
      },
      1280: {
        slidesPerView: 11.5,
      },
      1450: {
        slidesPerView: 13.5,
      },
      1600: {
        slidesPerView: 15.5,
      }
    }
  });
}
